import { Component } from '@angular/core';
import { IconName } from '../../enums/IconName.enum';
import { localizationKeys } from '../../utils/localizationKeys';

@Component({
    selector: 'app-intro-component',
    templateUrl: './appintro.component.html',
    styleUrls: ['./appintro.component.scss'],
})
export class AppIntroComponent {
    localizationKeys = localizationKeys;

    // TODO: check if it could be removed
    sideList: { localizationKey: keyof typeof localizationKeys; iconName: IconName }[] = [
        {
            localizationKey: localizationKeys.introListItem_flow,
            iconName: IconName.WRONG,
        },
        {
            localizationKey: localizationKeys.introListItem_process,
            iconName: IconName.CORRECT_IN_A_BOX,
        },
    ];
}
